module.exports = __webpack_public_path__ + "img/album14_42.629338b3.jpg";